import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { ThumbUpTwoTone } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toStoryIntro } from '../../utils/routes';

export default function FinishedFrame(props) {

    const navigate = useNavigate();

    return(
        <Paper sx={{display: "flex", flexDirection: "column", alignItems: "center", width: "16rem", height: "26rem", p: 2}}>
            <Typography variant="h1">Super!</Typography>
            <Box sx={{mt: 2, p: 2, display: "flex", flexDirection: "column", alignItems: "center"}}>
                <ThumbUpTwoTone color="secondary" sx={{fontSize: "8rem"}}/>
                <Typography>Pfad abgeschlossen</Typography>
                <Button sx={{mt: 2}} variant="contained" onClick={() => navigate(toStoryIntro)}>Zurück zur Übersicht</Button>
            </Box>
        </Paper>
    )
}